import React, { memo } from 'react';
import classNames from "classnames";

import Loader from "../../Loader";

import styles from './Button.module.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary';
    fullWidth?: boolean;
    loader?: boolean;
    children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = memo(({
  variant = 'primary',
  fullWidth = false,
  loader = false,
  children,
  ...props
}) => (
    <button className={classNames(styles.button, styles[variant], { [styles.fullWidth]: fullWidth })} {...props}>
        {loader ? <Loader /> : children}
    </button>
));

Button.displayName = 'Button';
